import { replace, length, splitAt, head, last, gt } from 'ramda';

export const redactTheTextFn = (
  message: string | undefined | any,
  redactText: string
) => {
  const content = message ? message : '';
  return replace(/[a-zA-Z0-9]/g, redactText, content);
};

export const redactSSN = (ssn: string | any) => {
  if (ssn && length(ssn) > 8) {
    const splited = splitAt(7, ssn);
    const redactText = head(splited);
    const remainingText = last(splited);
    return `${redactTheTextFn(redactText, 'X')}${remainingText}`;
  }
  return ssn;
};
export const redactBankAcountNumber = (bankAccountNumber: any) => {
  if (bankAccountNumber && gt(length(bankAccountNumber),8)) {
    const splited = splitAt(5, bankAccountNumber);
    const redactText = head(splited);
    const remainingText = last(splited);
    return `${redactTheTextFn(redactText, 'X')}${remainingText}`;
  }
  return bankAccountNumber;
}
